import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-6ba99b44"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "excelGuide pt-5" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "logo"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "py-4" }, null, -1))
const _hoisted_6 = { class: "step pt-5" }
const _hoisted_7 = { class: "fs_24 d-flex align-items-center mb-2" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "my-3" }, [
  /*#__PURE__*/_createElementVNode("li", null, "fabric code"),
  /*#__PURE__*/_createElementVNode("li", null, "composition"),
  /*#__PURE__*/_createElementVNode("li", null, "grams")
], -1))
const _hoisted_9 = { class: "step pt-5" }
const _hoisted_10 = { class: "fs_24 d-flex align-items-center mb-2" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "mt-3 mb-4" }, [
  /*#__PURE__*/_createElementVNode("li", null, "line"),
  /*#__PURE__*/_createElementVNode("li", null, "line description"),
  /*#__PURE__*/_createElementVNode("li", null, "complete description")
], -1))
const _hoisted_12 = { class: "step pt-5" }
const _hoisted_13 = { class: "fs_24 d-flex align-items-center mb-2" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "py-5" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_localized_text, {
          localizedKey: "Excel upload informations guide",
          text: "Excel upload informations guide",
          type: "h1",
          class: "my-5"
        })
      ]),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("strong", _hoisted_7, [
          _createTextVNode(" 1) "),
          _createVNode(_component_localized_text, {
            localizedKey: "Columns with mandatory values",
            text: "Columns with mandatory values",
            class: "ms-1"
          })
        ]),
        _createVNode(_component_localized_text, {
          localizedKey: "The order of the columns doesn't matter, the name instead must be the same of the followings",
          text: "The order of the columns doesn't matter, the name instead must be the same of the followings",
          class: "fs_18 d-block"
        }),
        _hoisted_8,
        _createVNode(_component_localized_text, {
          localizedKey: "N.B. Columns names MUST be in the first raw of your file, from the second one till the end you MUST provide the fabric data",
          text: "N.B. Columns names MUST be in the first raw of your file, from the second one till the end you MUST provide the fabric data",
          class: "d-block mt-2"
        })
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("strong", _hoisted_10, [
          _createTextVNode(" 2) "),
          _createVNode(_component_localized_text, {
            localizedKey: "Columns with non-mandatory values",
            text: "Columns with non-mandatory values",
            class: "ms-1"
          })
        ]),
        _createVNode(_component_localized_text, {
          localizedKey: "In order to have more specific output you can also share other informations",
          text: "In order to have more specific output you can also share other informations",
          class: "fs_18 d-block"
        }),
        _hoisted_11
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("strong", _hoisted_13, [
          _createTextVNode(" 3) "),
          _createVNode(_component_localized_text, {
            localizedKey: "Fields validation",
            text: "Fields validation",
            class: "ms-1"
          })
        ]),
        _createVNode(_component_localized_text, {
          localizedKey: "Due to work properly, the software needs some specific values in the following columns",
          text: "Due to work properly, the software needs some specific values in the following columns",
          class: "fs_18 d-block mb-3"
        }),
        _createVNode(_component_localized_text, {
          localizedKey: "“composition” field need to be like this: “99% Cotton-1% Elastane generic”. Materials need the percentage first and must be divided from “-” symbol. If you have more than one fabric, you must insert text “TESSUTO:” in the beginning of the list.",
          text: "“composition” field need to be like this: “99% Cotton-1% Elastane generic”. Materials need the percentage first and must be divided from “-” symbol. If you have more than one fabric, you must insert text “TESSUTO:” in the beginning of the list.",
          class: "d-block mb-1"
        }),
        _createVNode(_component_localized_text, {
          localizedKey: "E.g. TESSUTO: 99% Cotton-1% Elastane generic    TESSUTO: 94% Cotton-6% Elastane generic",
          text: "E.g. TESSUTO: 99% Cotton-1% Elastane generic    TESSUTO: 94% Cotton-6% Elastane generic",
          class: "d-block mb-2"
        })
      ]),
      _hoisted_14
    ])
  ]))
}